import { ClienteService } from './services/cliente.service';
import { MenuRepository } from '../../src/app/menus/domain/menu.repository';
import { RolRepository } from '../../src/app/roles/domain/rol.repository';
import { UserRepository } from './usuario/domain/user-repository';
import { UserOperations } from './usuario/infraestructura/user-operation';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { RolService } from './services/rol.service';
import { ManMenuService } from './services/manMenu.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationComponent } from './navigation/navigation.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { GeolocalizacionModule } from './geolocalizacion/geolocalizacion.module';
import { ProformaRepository } from './proforma/domain/proforma.repository';
import { ProformaService } from './services/proforma.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ClienteRepository } from './visitascliente/dominio/cliente.repository';
import { PageGestionvisitasComponent } from './gestionvisitas/presentacion/page-gestionvisitas/page-gestionvisitas.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AlertaDocumentoRepository } from './bandeja-alerta-documento/domain/alerta_documento_repository';
import { AlertaDocumentoService } from './services/alertaDocumento.service';
import { PreResRepository } from './cotizaciones_resumentes/domain/pre_res_repository';
import { PreResService } from './services/cotizacionResumen.service';
import { DashBoardRepository } from './dashboardVentas/domain/dashboard.repository';
import { DashBoardService } from './services/dashboard.service';
import { ComisionesRepository } from './comisiones/domain/Comisiones-repository';
import { ComisionesService } from './services/comisiones.service';
import { OvVersionarService } from './services/ovVersionar.service';
import { OvVersionarRepository } from './ovPorVersionar/domain/ov-por-versionar.repository';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { SoporteRepository } from './soporte/domain/soporte.repository';
import { SoporteService } from './services/soporte.service';
import { GestionSalasService } from './services/gestionSalas.service';
import { GestionSalasRepository } from './matenimiento_salas/domain/mante_salas_repository';
import { ReportesService } from './services/reportes.service';
import { OrderbyPipe } from './shared/components/orderby.pipe';
import { OperacionesRepository } from './mantenimientos/domain/operaciones.repository';
import { OperacionesService } from './services/operaciones.service';
import { CobranzasRepository } from './finanzas/cobranzas/domain/cobranzas_repository';
import { FinanzasService } from './services/finanzas.service';
import { GestionProyectosRepository } from './gestion-proyectos/domain/gestionProyectos-repository';
import { GestionProyectosService } from './services/gestionProyectos.service';
import { ComercialService } from './services/comercial.service';
import { ComercialRepository } from './repositorio/comercial.repository';
import { VisorComponent } from './comercial/reffer/visor-pdf/presentacion/visor/visor.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { CryptoRepository } from './interfaces/crypto-repository';
import { CryptoService } from './services/crypto.service';
import { DialogTableComponent } from './dialog-table/dialog-table.component';
import { operacionService } from './services/operacion.service';
import { OperacionRepository } from './repositorio/operacion.repository';
import { GestionUsuarioRepository } from './gestion-usuario/domain/gestion-usuario-repository';
import { GestionUsuarioService } from './services/gestion-usuario.service';
import { VentasRepository } from './comercial/ventas/ventas.repository';
import { VentasService } from './comercial/ventas/ventas.service';
import { CustomerRepository } from './comercial/customer/customer.repository';
import { CustomerService } from './comercial/customer/customer.service';
import { PricingService } from './supply/pricing/servicio/pricing.service';
import { ReporteTarifaRepository } from './supply/reportes/servicio/reporte-tarifa.repository';
import { ReporteTarifaService } from './supply/reportes/servicio/reporte-tarifa.service';
import { ReeferRepository } from './comercial/reefer/servicio/reefer.repository';
import { ReeferService } from './comercial/reefer/servicio/reefer.service';
import { MantenimientoRespository } from './mantenimiento/servicio/mantenimiento.repository';
import { MantenimientoService } from './mantenimiento/servicio/mantenimiento.service';
import { PricingRepository } from './supply/pricing/servicio/pricing.repository';
import { LogisticaRepository } from './supply/logistica/servicio/logistica.repository';
import { LogisticaService } from './supply/logistica/servicio/logistica.service';
import { VisorarchivosComponent } from './finanzas/visorarchivos/visorarchivos.component';
import { SolicitudAtencionRepository } from './extranet/solicitud-atencion/servicio/solicitud-atencion.repository';
import { SolicitudAtencionService } from './extranet/solicitud-atencion/servicio/solicitud-atencion.service';
import { IndexdbRepository } from './repositorio/indexdb.repository';
import { IndexdbService } from './services/indexdb.service';
import { AppComponent } from './app.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgChartsModule, NgChartsConfiguration } from 'ng2-charts';
import { LayoutModule } from '@angular/cdk/layout';
import { AppRoutingModule } from './app-routing.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ReportesRepository } from './repositorio/reportes.repository';
import { theme } from 'src/theme/theme.prime';
import { ReporteOperacionService } from './operacion/reportes/servicio/reporte-operacion.service';
import { ReporteOperacionRepository } from './operacion/reportes/servicio/reporte-operacion.repository';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { parametrosRepository } from './parametros/servicio/parametros.repository';
import { ParametrosService } from './parametros/servicio/parametros.service';
import { AdministracionRepository } from './administracion/servicio/administracion.repository';
import { AdministracionService } from './administracion/servicio/administracion.service';
import { BandejaTransporteComponent } from './supply/servicio-logistico/transporte/presentacion/bandeja-transporte/bandeja-transporte.component';
import { ToastModule } from 'primeng/toast';
import { CustomReuseStrategy } from './core/presentacion/components/custom-reuse.strategy';
import { MultiLanguageSpellcheckDirective } from './shared/directives/multi-language-spellcheck.directive';
import { GestionCorreosService } from './shared/servicios/gestion-correos/gestion-correos.service';
import { GestionCorreosRepository } from './shared/servicios/gestion-correos/gestion-correos.repository';

//@ts-ignore
@NgModule({
    declarations: [
        AppComponent,
        NavigationComponent,
        PageGestionvisitasComponent,
        OrderbyPipe,
        VisorComponent,
        DialogTableComponent,
        VisorarchivosComponent
    ],
    bootstrap: [AppComponent]
    , imports: [
        // CommonModule,
        PdfViewerModule,
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        CoreModule,
        AppRoutingModule,
        MatInputModule,
        RouterModule.forRoot([]),

        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        NgChartsModule,
        LayoutModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatGridListModule,
        MatCardModule,
        MatMenuModule,
        GeolocalizacionModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatFormFieldModule,
        NgChartsModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        ButtonModule,
        PdfViewerModule,
        OverlayPanelModule,
        ToastModule,
        MultiLanguageSpellcheckDirective,
    ]
    , providers: [
        // todo lo que se necesita que se instacie una vez se tieen que poner aca en el provider
        DatePipe,
        { provide: UserRepository, useClass: UserOperations }, { provide: APP_BASE_HREF, useValue: '/' },
        { provide: RolRepository, useClass: RolService },
        { provide: MenuRepository, useClass: ManMenuService },
        { provide: ProformaRepository, useClass: ProformaService },
        { provide: ClienteRepository, useClass: ClienteService },
        { provide: AlertaDocumentoRepository, useClass: AlertaDocumentoService },
        { provide: PreResRepository, useClass: PreResService },
        { provide: DashBoardRepository, useClass: DashBoardService },
        { provide: ComisionesRepository, useClass: ComisionesService },
        { provide: OvVersionarRepository, useClass: OvVersionarService },
        { provide: SoporteRepository, useClass: SoporteService },
        { provide: ReportesRepository, useClass: ReportesService },
        { provide: OperacionesRepository, useClass: OperacionesService },
        { provide: GestionSalasRepository, useClass: GestionSalasService },
        { provide: CobranzasRepository, useClass: FinanzasService },
        { provide: ComercialRepository, useClass: ComercialService },
        { provide: CryptoRepository, useClass: CryptoService },
        { provide: GestionProyectosRepository, useClass: GestionProyectosService },
        { provide: GestionUsuarioRepository, useClass: GestionUsuarioService },
        { provide: VentasRepository, useClass: VentasService },
        { provide: CustomerRepository, useClass: CustomerService },
        { provide: PricingRepository, useClass: PricingService },
        { provide: LogisticaRepository, useClass: LogisticaService },
        { provide: OperacionRepository, useClass: operacionService },
        { provide: ReporteTarifaRepository, useClass: ReporteTarifaService },
        { provide: ReeferRepository, useClass: ReeferService },
        { provide: MantenimientoRespository, useClass: MantenimientoService },
        { provide: SolicitudAtencionRepository, useClass: SolicitudAtencionService },
        { provide: AdministracionRepository, useClass: AdministracionService },
        { provide: ReporteOperacionRepository, useClass: ReporteOperacionService },

        { provide: parametrosRepository, useClass: ParametrosService },
        { provide: GestionCorreosRepository, useClass: GestionCorreosService },

        { provide: IndexdbRepository, useClass: IndexdbService },
        { provide: LOCALE_ID, useValue: 'es' },
        { provide: NgChartsConfiguration, useValue: { generateColors: false } },
        { provide: NgChartsConfiguration, useValue: { generateColors: false } },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }, //BarcodeScanner
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        // { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }, // Se agrego para el manejo de rutas
        DatePipe,
        ConfirmationService,
        DialogService,
        MessageService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG(theme),
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
    ]
})
export class AppModule { }